var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81448 13.1853C3.12373 13.495 3.49112 13.7406 3.89556 13.9078C4.29999 14.0751 4.73349 14.1608 5.17114 14.16C5.6089 14.1608 6.04249 14.0751 6.44703 13.9078C6.85157 13.7405 7.21908 13.495 7.52848 13.1853L9.41381 11.2993L8.47114 10.3567L6.58581 12.2427C6.21012 12.6167 5.70159 12.8266 5.17148 12.8266C4.64136 12.8266 4.13283 12.6167 3.75715 12.2427C3.38281 11.8671 3.17262 11.3586 3.17262 10.8283C3.17262 10.2981 3.38281 9.78951 3.75715 9.414L5.64315 7.52866L4.70048 6.58599L2.81448 8.47133C2.19035 9.09697 1.83984 9.94461 1.83984 10.8283C1.83984 11.712 2.19035 12.5597 2.81448 13.1853ZM13.1851 7.52866C13.8089 6.90285 14.1592 6.05527 14.1592 5.17166C14.1592 4.28805 13.8089 3.44047 13.1851 2.81466C12.5595 2.19053 11.7119 1.84003 10.8281 1.84003C9.94443 1.84003 9.09678 2.19053 8.47114 2.81466L6.58581 4.70066L7.52848 5.64333L9.41381 3.75733C9.7895 3.38332 10.298 3.17335 10.8281 3.17335C11.3583 3.17335 11.8668 3.38332 12.2425 3.75733C12.6168 4.13284 12.827 4.64144 12.827 5.17166C12.827 5.70188 12.6168 6.21048 12.2425 6.58599L10.3565 8.47133L11.2991 9.414L13.1851 7.52866Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64255 11.3L4.69922 10.3573L10.3572 4.7L11.2999 5.64333L5.64255 11.3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.30777234eac5c2be3331cc083d90ac12.svg";
export { ForwardRef as ReactComponent };